<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-7 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Вход</h4>
                  <p class="mb-0">Введите свой адрес электронной почты и пароль для входа</p>
                </div>
                <div class="card-body">
                  <form role="form" @submit.prevent="login">
                    <div class="mb-3">
                      <argon-input
                          v-model="this.email"
                          :value="this.email"
                          type="email"
                          placeholder="Email"
                          name="email"
                          size="lg"
                          :is-required="true"
                          @change="onChangeInputEmail"
                      />
                    </div>
                    <div class="mb-3">
                      <argon-input
                          v-model="this.password"
                          type="password"
                          placeholder="Password"
                          name="password"
                          size="lg"
                          :value="this.password"
                          :is-required="true"
                          @change="onChangeInputPass"
                      />
                    </div>
                    <div class="text-center">
                      <argon-button class="mt-4" variant="gradient" color="success" fullWidth size="lg">Войти</argon-button>
                    </div>
                  </form>
                  <div v-if="loginError" class="mt-3 text-danger">
                    {{ loginError }}
                  </div>
                </div>
              </div>
            </div>
            <div class="top-0 my-auto text-center col-3 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column">
              <div
                  class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                  :style="{ backgroundImage: `url(${require('@/assets/img/back-log.jpg')})`, backgroundSize: 'cover' }"
              >
                <span class="mask bg-gradient-success opacity-6"></span>
                <h4 class="mt-5 text-white font-weight-bolder position-relative">Панель управления Аренды Туристического оборудования</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import {login} from "@/services/auth.js";
import axios from '@/axios';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Signin",
  components: {
    ArgonInput,
    ArgonButton,
  },
  data() {
    return {
      email: "",
      password: "",
      loginError: null,
    };
  },
  methods: {
    async login() {
      if (!this.email || !this.password) {
        this.loginError = "Пожалуйста, введите email и пароль";
        return;
      }

      try {
        const response = await axios.post("/login", {
          email: this.email,
          password: this.password,
        });

        await login(response.data.token);

        await this.$router.push({name: "Заказы"});
      } catch (error) {
        console.error("Ошибка входа:", error);
        this.loginError = "Неверный логин или пароль";
      }
    },
    onChangeInputEmail(event) {
      this.email = event.target.value.trim();
    },
    onChangeInputPass(event) {
      this.password = event.target.value.trim();
    },
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
};
</script>
